import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50caa100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CompletedCargos" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "CompletedCargos__title" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center text-gray-400 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_completed_cargo = _resolveComponent("completed-cargo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(" Созданные грузы "),
        (_ctx.cargos.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("(" + _toDisplayString(_ctx.cargos.length) + ")", 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.cargos.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Список пуст "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cargos, (cargo, i) => {
      return (_openBlock(), _createBlock(_component_completed_cargo, {
        cargo: cargo,
        key: i,
        index: i,
        disabled: _ctx.disabled,
        "additional-services": _ctx.additionalServices,
        "is-bosch": _ctx.isBosch,
        onDelete: _ctx.emitDeleteCargo,
        onUpdate: _ctx.emitUpdateCargo,
        onUpdateAdditionalServices: _ctx.emitUpdateAdditionalServices
      }, null, 8, ["cargo", "index", "disabled", "additional-services", "is-bosch", "onDelete", "onUpdate", "onUpdateAdditionalServices"]))
    }), 128))
  ]))
}